import { IAppState } from '../../redux';

export function selectTotalPrice(state: IAppState): number {
  const {
    checkoutInfo: {
      writeOffInfo: { amount },
    },
  } = state;

  return amount;
}
